exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".annotation-list{padding-right:10px;overflow-y:scroll;position:relative}\n", ""]);
